import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface FileCategoriesResponse {
  categories: FileCategoriesResponse_Category[];
}

export interface FileCategoriesResponse_Category {
  id: string;
  type: string;
}

export const useFileCategories = () => {
  return useApi<FileCategoriesResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<FileCategoriesResponse>(
          "/charting/files/categories",
        );

        return response.data;
      },
      queryKey: QueryKeys.Reference.Files.CATEGORIES,
    },
  });
};
